import { useTheme } from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetPaginator({
  isNextDisabled,
  isPrevDisabled,
  onNextClick,
  onPrevClick
}) {
  const trellisTheme = useTheme();
  if (isNextDisabled && isPrevDisabled) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsxs(Button, {
      disabled: isPrevDisabled,
      onClick: onPrevClick,
      size: "default",
      use: "transparent",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        color: isPrevDisabled ? undefined : trellisTheme.color['do-not-use-calypso-dark'],
        name: "left"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.tabs.assets.paginator.prev"
      })]
    }), /*#__PURE__*/_jsxs(Button, {
      disabled: isNextDisabled,
      onClick: onNextClick,
      size: "default",
      use: "transparent",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.tabs.assets.paginator.next"
      }), /*#__PURE__*/_jsx(UIIcon, {
        color: isNextDisabled ? undefined : trellisTheme.color['do-not-use-calypso-dark'],
        name: "right"
      })]
    })]
  });
}